import React from 'react';
import { Check, Zap, CreditCard, Globe, Smartphone } from 'lucide-react';
export function WhatYouReceiveSection() {
  const items = ['Guía digital paso a paso', 'Checklist de mochila sensorial', 'Plan de acción de 60 segundos', 'Diario de disparadores', 'Tarjeta visual imprimible', 'Acceso inmediato en español'];
  const trustBullets = [{
    icon: <Zap className="w-4 h-4 text-[#D4A853]" data-id="element-219" />,
    text: 'Acceso inmediato después del pago'
  }, {
    icon: <CreditCard className="w-4 h-4 text-[#D4A853]" data-id="element-220" />,
    text: 'Pago único, sin mensualidades'
  }, {
    icon: <Globe className="w-4 h-4 text-[#D4A853]" data-id="element-221" />,
    text: 'Material 100% en español'
  }, {
    icon: <Smartphone className="w-4 h-4 text-[#D4A853]" data-id="element-222" />,
    text: 'Úsalo desde tu celular'
  }];
  return <section className="bg-white py-12 md:py-16 px-5" data-id="element-223">
      <div className="max-w-2xl mx-auto" data-id="element-224">
        <div className="text-center mb-8" data-id="element-225">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2D1F0E] mb-3" data-id="element-226">
            Qué recibes exactamente al acceder hoy
          </h2>
          <p className="text-[0.95rem] md:text-base text-[#6B5D4F] leading-relaxed" data-id="element-227">
            Todo está pensado para darte claridad práctica en el momento
            difícil, sin improvisar.
          </p>
        </div>

        <div className="bg-[#FDF8F0] rounded-2xl p-6 md:p-8 border border-[#D4A853]/20 mb-6" data-id="element-228">
          <div className="space-y-3" data-id="element-229">
            {items.map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-230">
                <Check className="w-5 h-5 text-[#4A6741] flex-shrink-0" data-id="element-231" />
                <span className="text-[#2D1F0E] font-medium text-[0.9rem] md:text-base" data-id="element-232">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Trust box */}
        <div className="bg-[#F0F4EC] rounded-2xl p-5 md:p-6 border border-[#4A6741]/15" data-id="element-233">
          <h3 className="text-base md:text-lg font-bold text-[#4A6741] mb-4 text-center" data-id="element-234">
            Acceso simple y directo
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-235">
            {trustBullets.map((bullet, idx) => <div key={idx} className="flex items-center gap-2.5" data-id="element-236">
                {bullet.icon}
                <span className="text-[#2D1F0E] text-sm md:text-[0.9rem] font-medium" data-id="element-237">
                  {bullet.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}